import { useContext, useState, useEffect } from 'react'
import DocumentTab from './documentTab'
import { ActiveEnterpriseContext } from '../../../../context/activeEnterpriseContext'
import { useGetDocumentsEnterpriseQuery } from '../../../../hooks/api/entreprises'
import { MRT_SortingState } from 'material-react-table'

const DocumentsEntreprise = ({
  filter
}: {
  filter: any
}) => {
  const [sorting, setSorting] = useState<MRT_SortingState>([{ id: 'active_date', desc: true }])
  const [page, setPage] = useState('1')
  const { activeEnterprise } = useContext(ActiveEnterpriseContext)

  // Reset pagination when filter changes
  useEffect(() => {
    setPage('1')
  }, [filter])

  const { data, isFetching } = useGetDocumentsEnterpriseQuery(activeEnterprise.crm_id, {
    page,
    sort: sorting[0],
    filter,
  })
  return (
    <DocumentTab
      propsTable={{
        data: data?.data ?? [],
        state: { sorting, isLoading: isFetching },
        onSortingChange: (params) => {
          setPage('1')
          setSorting(params)
        },
        propsPagination: {
          page: Number(page),
          count: data?.metadata?.total && (Number(data.metadata.total) > 0) ? Math.ceil(Number(data.metadata.total) / 10) : 1,
          onChange: (e, index) => {
            setPage(index.toString())
          },
        },
       
      }}
      type="enterprise"
      text='Dans cet onglet se trouvent les documents liés au membrership de votre entreprise (copie du contrat d’adhésion ou de renouvellement d’adhésion, preuve de cautionnement de licence RBQ, documents achetés par l’entreprise, etc.).'
    />
  )
}

export default DocumentsEntreprise
